<div class="p-2" style="position: relative; word-break: break-all">

  <div style=" position: 'absolute'; right: '5px' ">
    <div class="dropdown d-flex justify-content-end">
      <i class='bx bx-dots-vertical-rounded' style="font-size: 1.5rem; padding: 5px; cursor: pointer;"
        id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false"></i>
      <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
        <li><a class="dropdown-item" [routerLink]="[user?.id, 'edit']" translate>global.edit</a></li>
        <li *ngIf="['root', 'user'].includes(currentUser?.role?.name)"><a class="dropdown-item"
            (click)="toggleChangePassword = true" translate>global.changePassword</a></li>
        <li *ngIf="filialId"><a class="dropdown-item" (click)="onUnassign.emit(user)" translate>filials.unassignAdmin</a></li>
        <hr style="margin: 0.5rem;">
        <li><a class="dropdown-item" (click)="onDelete(user)" translate>global.delete<i
              class="fa fa-trash ms-2"></i></a></li>
      </ul>
    </div>
  </div>

  <div class="pt-3 text-center">
    <div style="display: inline-block; position: relative;">
      <ng-template [ngIf]="user.profileImage !== null" [ngIfElse]="uploadImage">
        <img class="user-image"  src="{{user.profileImage}}" alt="">
      </ng-template>
      <ng-template #uploadImage>
        <span>
          <i class='bx bx-user user-icon small_user_icon'></i>
        </span>
      </ng-template>
      <div *ngIf="user.onlineColor" class="circle" [ngStyle]="{'background-color': user.onlineColor}"></div>
    </div>
  </div>

  <p class="online">{{user.online}}</p>

  <div class="mt-3 text-center">
    <p class="user_name">{{user.name}}</p>
    <p class="small">{{user.email}}</p>
    <!-- 
      {isAdmin && !isRootMenu && (
        <DefaultBadge text={'Admin'} isAdmin={true} />
      )} -->
  </div>
  <div style="height: 25px;"></div>
  <div class="small mb-2">

    <div>
      <span>
        <i class='bx bx-home icon_color me-2'></i>
      </span>
      <span class="small">{{user.address || '/'}}</span>
    </div>

    <div>
      <span>
        <i class='bx bxs-phone icon_color me-2'></i>
      </span>
      <span class="small">{{user.phone || '/'}}</span>
    </div>

    <div>
      <span>
        <i class='bx bx-user icon_color me-2'></i>
      </span>
      <span class="small">{{user.createdAt | date: 'dd/MM/yyyy HH:mm:ss'}}</span>
    </div>

  </div>

  <ng-container *ngIf="userType === 'filialAdmin' && !filialId">
    <div class="divider"></div>
    <div class="text-center">
      <div class="d-flex justify-content-between" *ngIf="!user.filials.length">
        <span translate>filials.noFilials</span>
        <button class="custom_button" (click)="seeFilials.emit(user)" translate>global.assign</button>
      </div>
      <button *ngIf="user.filials.length" class="custom_button" (click)="seeFilials.emit(user)" translate>filials.seeFilials</button>
    </div>
  </ng-container>

  <ng-container *ngIf="userType === 'worker'">
    <div class="divider"></div>
    <div class="text-center">
      <!-- <div class="d-flex justify-content-between" *ngIf="!user.filials.length">
        <span>No Inventars</span>
        <button class="custom_button" (click)="seeInventars.emit(user)">Assign</button>
      </div> -->
      <button class="custom_button" (click)="seeInventars.emit(user)" translate>filials.filial.seeInventars</button>
    </div>
  </ng-container>
</div>

<app-modal (close)="toggleChangePassword = !toggleChangePassword" *ngIf="toggleChangePassword">
  <div class="modal_container"
    style="text-align: initial; font-weight: 300 !important; letter-spacing: 1px; color: #15171a;">
    <div class="modal-body">
      <app-change-password-form (close)="toggleChangePassword = false;"
        (onChangePassword)="changePasswordHandler($event)"></app-change-password-form>
    </div>
  </div>
</app-modal>